<template>
    <div cols="12" class="mb-3" v-if="review != null" no-wrap rounded>
      <small class="text-muted font-weight-bold">{{ review.platform }}</small>
      <div class="d-flex justify-content-between">
        <strong>{{ review.clientName }}</strong>
        <div class="text-muted">
          <small>#{{ review.serviceNumber }}</small>
        </div>
      </div>
      
      <div class="d-flex justify-content-between">
        <small class="text-muted">{{ review.product }}</small>
        <small class="text-muted">{{ review.supplier }}</small>
      </div>
      
      <md-icon
        v-for="(star, index) in 5"
        v-bind:key="star"
        icon="star"
        :class="getStarColor(review.rate, index)"
        style="font-size: 12px;"/>
      <small class="text-muted ml-2">{{ review.reviewedAt }}</small>
      <md-icon v-if="review.rate <= 2" icon="warning" class="text-danger ml-2"/>
  
      <div>
        <small v-if="review.review != ''" class="text-justify">{{ review.review }}</small>
        <small v-else class="text-muted">- Sin comentarios del cliente. -</small>
      </div>
    </div>
  </template>
  
  <script>
    export default {
      props: {
        review: {
          type: Object,
          required: true
        }
      },
      components: {},
      data() {
        return {
        }
      },
      methods: {
        getStarColor(stars_round, index) {
          let color = (stars_round >= index + 1) ?'text-warning' : 'text-secondary';
          return 'font-weight-bolder '+color
        }
      },
      mounted() {
      }
    } 
  </script>